import { Select, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ISelectOption } from '../../models/utils/selectOption'
import { defaultFilterOption } from '../../utils'
import { useGetDataOnScroll } from '../getDataOnScrollProps/useGetDataOnScrollProps'
import { getCookie } from 'typescript-cookie'
import { useLazyGetTerritorialUnitsListQuery } from '../../redux/api/handBooksApi/territorialUnitsApi'
import { EntTerritorialsUnits } from '../../models/handBooks/territorialsUnits'
import { EntTerritorialUnitsFilter } from '../../models/filters/territorialUnitsFilter'

interface IProps {
	multiple?: boolean
	value?: number | string | null
	type?: ('AREA' | 'REGION' | 'CITY_OF_REPUBLICAN_SIGNIFICANCE')[]
	onChange?: (value: number | string, option?: any) => void
	status?: any
	parentId?: number | null
	areaCode?: string | null
}

const SelectTerritorialUnitsKurultai = (props: IProps) => {
	const { t } = useTranslation()
	const [options, setOptions] = useState<ISelectOption[]>([])

	const [getData] = useLazyGetTerritorialUnitsListQuery()
	const { fetching, data, setData, setFetching, setFilter, scrollHandler, setCurrentPage } =
		useGetDataOnScroll<EntTerritorialsUnits, EntTerritorialUnitsFilter>({
			initialFilter: new EntTerritorialUnitsFilter({
				type: props.type,
				parentId: props.parentId,
				areaCode: props.areaCode,
				id: props.type?.includes('REGION') && props.value != null ? Number(props.value) : null,
			}),
			query: getData,
		})

	useEffect(() => {
		const optionss = Array.from(new Set(data)).map(a => {
			return {
				label: getCookie('i18next') === 'ky' ? `$ ${a.nameKy}` : ` ${a.nameRu}`,
				value: !props.type || props.type?.includes('REGION') ? a.id ?? '' : a.code,
				data: { id: a.id, polygonJson: a.polygonJson, code: a.code },
			}
		})
		setOptions(optionss)
	}, [data])

	useEffect(() => {
		const filter = new EntTerritorialUnitsFilter()
		filter.type = props.type ?? null
		filter.parentId = props.parentId ?? null
		filter.areaCode = props.areaCode ?? null

		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}, [props.parentId, props.areaCode])

	const search = (value: string) => {
		const filter = new EntTerritorialUnitsFilter()
		filter.name = value
		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	const clear = () => {
		const filter = new EntTerritorialUnitsFilter()
		filter.name = null

		if (props.type) {
			filter.type = props.type
		}
		filter.parentId = props.parentId ?? null
		filter.areaCode = props.areaCode ?? null

		setFilter(filter)
		setData([])
		setCurrentPage(0)
		setFetching(true)
	}

	const selectMode = props.multiple ? 'multiple' : undefined

	let selectValue: string | string[] | undefined
	if (props.value == null) {
		selectValue = undefined
	} else if (Array.isArray(props.value)) {
		selectValue = props.value.map(String)
	} else {
		selectValue = String(props.value)
	}

	return (
		<Select
			placeholder={t('msg.selectPlaceholder')}
			mode={selectMode}
			onClear={clear}
			onSearch={search}
			onPopupScroll={scrollHandler}
			loading={fetching}
			value={props.value}
			onChange={props.onChange}
			options={options}
			status={props.status}
			filterOption={defaultFilterOption}
			showSearch
			style={{ width: '100%' }}
			allowClear
			dropdownRender={menu => <Spin spinning={fetching}>{menu}</Spin>}
		/>
	)
}

export default SelectTerritorialUnitsKurultai
